import * as React from 'react'

import { Box, Icon, LargeIcon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  icon: LargeIcon
  description: string
  showArrow?: boolean
}

const Step = ({ icon, description, showArrow }: Props) => {
  return (
    <Box gap="s8" alignItems="center" flexDirection="column" textAlign="center" width="s240">
      <Icon.Large icon={icon} color="grey800" />
      <Box flexDirection="row">
        <Text.Normal color="grey800">{description} </Text.Normal>
        <Box>{showArrow && <Icon.Medium icon="arrow-right" color="grey600" />}</Box>
      </Box>
    </Box>
  )
}
export default Step
